export const SET_SOCKET_MESSAGE = 'SET_SOCKET_MESSAGE';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const GET_SELECTED_USER = 'GET_SELECTED_USER';
